import React, { useEffect, useState } from 'react';
import DOMPurify from 'dompurify';
import { useNavigate } from 'react-router-dom';
import getBaseUrl from './../../utils/baseUrl';
import BackButton from './../BackButton.jsx';
import useAndroidBody  from './../hooks/useAndroidBody.js';

const fetchGuideHtml = async (fileName) => {
  const res = await fetch(`${getBaseUrl()}/guides/android/${fileName}`);
  if (!res.ok) throw new Error(`Failed to fetch ${fileName}`);
  const text = await res.text();
  return DOMPurify.sanitize(text);
};

export default function InstallOver14() {
  useAndroidBody();
  const nav = useNavigate();
  const [html, setHtml] = useState('');
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    (async () => {
      try {
        setLoading(true);
        const c = await fetchGuideHtml('android2.html');
        setHtml(c);
      } finally {
        setLoading(false);
      }
    })();
  }, []);

  return (
    <div className="android-install ai-wrap">
      <header className="ai-header"><div className="ai-header__title"><span>Android 14+ steps</span></div></header>
      <main className="ai-main">
      <BackButton />
        <section className="card">
          {loading ? <div className="skeleton"><div className="skeleton__line"/></div>
                   : <div className="html-content" dangerouslySetInnerHTML={{ __html: html }} />}
          <button className="btn btn--primary" onClick={() => nav('/android/final-checks')}>Continue</button>
        </section>
      </main>
    </div>
  );
}
